module.exports = __webpack_public_path__ + "static/media/blind.b888097f.svg";